import React from 'react';
import { LoadingOutlined } from '@ant-design/icons';
import { Spin } from 'antd';

const Spinner = ({ className = ''}) => {
  const spinIcon = <LoadingOutlined style={{ fontSize: 36 }} spin />;
  return (
    <div
      className={className}
      style={{
        textAlign: 'center',
        borderRadius: 4,
        marginBottom: 20,
        padding: '30px 50px',
        margin: '20px 0',
      }}
    >
      <Spin indicator={spinIcon} />
    </div>
  );
};

export default Spinner;
